/**
 * 判断浏览器设备
 * @param userAgent 用户代理字符串，默认为空字符串
 * @returns 包含操作系统和浏览器的对象
 - system: 操作系统名称
 - browser: 浏览器名称
 */
export function browserDevice(userAgent?: string) {
    if (!userAgent) {
        if (typeof window === "undefined") {
            return {
                system: "",
                browser: "",
            };
        }
        userAgent = window.navigator.userAgent;
    }
    // 判断操作系统
    let system = "";
    if (userAgent.indexOf("Windows") != -1) {
        system = "Windows";
    } else if (userAgent.indexOf("Macintosh") != -1) {
        system = "Mac OS";
    } else if (userAgent.indexOf("Linux") != -1) {
        system = "Linux";
    } else if (userAgent.indexOf("Android") != -1) {
        system = "Android";
    } else if (userAgent.indexOf("like Mac OS X") != -1) {
        system = "iOS";
    }

    // 判断浏览器
    let browser = "";
    if (userAgent.indexOf("Chrome") != -1) {
        browser = "Chrome";
    } else if (userAgent.indexOf("Firefox") != -1) {
        browser = "Firefox";
    } else if (userAgent.indexOf("Safari") != -1) {
        browser = "Safari";
    } else if (userAgent.indexOf("Opera") != -1) {
        browser = "Opera";
    } else if (
        userAgent.indexOf("MSIE") != -1 ||
        userAgent.indexOf("Trident") != -1
    ) {
        browser = "IE";
    } else if (userAgent.indexOf("Edge") != -1) {
        browser = "Edge";
    }

    return { system, browser };
}

/**
 * 确定用户类型
 * @param jwt 是否登录，存在即登录
 * @param is_old_customer 是否是老用户
 * @returns 2（已登录 + 已下单 老用户）4（未登录）5（已登录 + 未下单）
 */
export function determineUserType(jwt: string, is_old_customer: boolean) {
    let userType = 4;
    if (jwt) {
        if (is_old_customer) {
            userType = 2;
        } else {
            userType = 5;
        }
    }
    return userType;
}

export function getCmsProviderData(pageData: any) {
    const providerNeedData = ["H5Nav"];
    return pageData.filter((item: any) => providerNeedData.includes(item.name));
}

export const getCmsConfig = (data: Record<string, any> = {}) => {
    //数组为空的时候不展示cms
    let config = {};
    for (let key in data) {
        try {
            data[key] =
                typeof data[key] === "string"
                    ? JSON.parse(data[key])
                    : data[key];
        } catch (error) {
            console.error("getCmsConfig", error);
        }
    }

    config = data;
    return {
        ...config,
    };
};
